import {createI18n} from 'vue-i18n'
import {lang} from './lang.js'

var lan

if(localStorage.getItem("lang")=== null){
  var stringJson = JSON.stringify({"display": "አማርኛ","identifier": 'am'})
  localStorage.setItem("lang", stringJson)
  lan = 'am'
}else{
  lan = JSON.parse(localStorage.getItem("lang")).identifier 
}

const vueI18n =  createI18n({
    legacy: false,
    locale: lan || 'am',
    globalInjection: true,
    messages: {
      en: lang.en,
      am: lang.am,
    }

  })

  export default vueI18n